import { event } from '@uhg-abyss/web/tools/event';
import { storage } from '@uhg-abyss/web/tools/storage';
import { userEvent } from './events';
import {
  validateUserRequest,
  getUserDetailsRequest,
  getAdminInfo,
} from './requests';

export const validateUserSaga = async () => {
  event.setData(userEvent());
  const user = await getUserDetailsRequest();
  const data = await validateUserRequest(user.uuid);
  let adminInfo;

  // needed when user submits a qualtrics survey.
  if (user.uuid) {
    storage.session.set('qualtrics_uuid', user.uuid);
  }
  // 'DSA:V:USR:NU' (new user) returns data.id as empty. ID attribute must be populated for getAdminInfo
  if (data.isUserApiError && data.code !== 'DSA:V:USR:NU') {
    adminInfo = await getAdminInfo(data.id);

    if (adminInfo?.data.adminErrCode && adminInfo?.data.adminErrMessage) {
      user.adminErrCode = adminInfo?.data.adminErrCode;
      user.adminErrMessage = adminInfo?.data.adminErrMessage;
      user.adminInfo = {};
    } else {
      user.adminInfo = adminInfo?.data || {};
    }
  } else if (
    (data.isUserApiError && data.code === 'DSA:V:USR:NU') ||
    !data.providerOrg ||
    data.providerOrg.length === 0
  ) {
    // if userError and error code is New User OR if no providerOrg or providerOrg is an empty array
    user.adminInfo = {};
  } else {
    adminInfo = await getAdminInfo(data.providerOrg[0].id);
    user.adminInfo = adminInfo?.data || {};
  }

  event.setData(userEvent(user, data));
  return {
    ...user,
    ...data,
  };
};
export const getUserDetailsSaga = async () => {
  const data = await getUserDetailsRequest();
  return data;
};
